import axios from 'axios';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Alert } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MyContext } from '../components/helper/MyContext';
const FormData = require('form-data');

export default function Home() {
    const navigate = useNavigate();
    const [submit, setSubmit] = useState('');
    const [username, setUsername] = useState('');
    const [password, serPassword] = useState('');
    const [usernameValid, setUsernameValid] = useState(false);
    const [passwordValid, serPasswordValid] = useState(false);
    const { setUser } = useContext(MyContext);

    const login = () => {
        setSubmit(true);
        let data = new FormData();
        data.append('username', username);
        data.append('password', password);

        var requestOptions = {
            method: 'POST',
            body: data,
            redirect: 'follow'
        };

        fetch("https://khpc.ir/api-supplier/api/login", requestOptions)
            .then(response => response.json())
            .then(response => {
                if (response.error) {
                    setUsernameValid(true);
                    serPasswordValid(true);
                    alert(response.message);
                    setSubmit(false);
                } else {
                    setUser(response.result.id)
                    navigate('/start')
                }
            })
            .catch(error => setSubmit(false));

        // let config = {
        //     method: 'post',
        //     maxBodyLength: Infinity,
        //     url: 'https://khpc.ir/api-supplier/api/login',
        //     data: data
        // };

        // axios.request(config)
        //     .then((response) => {
        //         if (response.data.error) {
        //             setUsernameValid(true);
        //             serPasswordValid(true);
        //             alert(response.data.message);
        //             setSubmit(false);
        //         } else {
        //             setUser(response.data.result.id)
        //             navigate('/start')
        //         }
        //     })
        //     .catch((error) => {
        //         setSubmit(false);
        //         console.log(error);
        //     });
    }
    return (
        <>
            <Container className='mt-2 py-5'>
                <Row>
                    <Col xs={12} md={12}>
                        <h3 style={{ color: '#223e7d' }} className='text-center fw-bold'>سامانه ثبت تامین کنندگان و پیمانکاران</h3>
                        <div className='mt-4'>
                            <p className='text-g'>قابل توجه کلیه موسسات، شرکت‌ها، فروشگاه‌ها و پیمانكاران داوطلب تامین کننده کالا و خدمات برای
                                شرکت پتروشیمی خراسان</p>
                            <p className='text-g'>
                                با سلام
                                ضمن اظهار خرسندی از ایجاد زمینه همكاری، به اطلاع می‌رساند درصورت تمایل به همكاری، تعامل و مشارکت در تامین کالا و خدمات این شرکت، لطفا جهت دریافت نام كاربری و كلمه عبور با شماره‌های 0583133(داخلی 2549) واحد بررسی منابع تماس حاصل فرمایید. متمنی است پس از اقدام یك هفته بعد ازبارگذاری اطلاعات در سایت پتروشیمی خراسان مجددا تماس حاصل فرموده و تاییدیه دریافت نمایید.
                            </p>
                            <p className='text-g'>
                                (خاطر نشان می‌گردد با توجه به درخواست‌های فراوان شركت‌ها و محدودیت‌های دیگر، انجام فرآیندها زمان بر است)
                            </p>
                            <div>
                                <Alert className='text-g'>
                                    به روز رسانی اطلاعات تخصصی (بسیار مهم)
                                    در صورتی كه در لیست تامین كنندگان كالا و خدمات شركت پتروشیمی خراسان ثبت می باشید جهت به روز رسانی اطلاعات(ازقبیل بارگذاری مجوزها با تاریخ اعتبار جدید و ...) با شماره 0583133 داخلی 2549 واحد بررسی منابع شركت پتروشیمی خراسان تماس گرفته و پس از اخذ نام كاربری و رمز عبور جدید نسبت به روز آمد نمودن اطلاعات اقدام گردد.
                                </Alert>
                            </div>

                            <div className='mt-2'>
                                <p className='text-g'>معیارهایی که ارزیابی شرکتها در بدو ورود به لیست وندور پتروشیمی خراسان و پایش عملکرد آنها در طول دوران همکاری بر اساس آنها انجام می‌شود:</p>
                            </div>
                        </div>
                    </Col>
                    <Col md={6} className='mt-4'>
                        <h5 style={{ color: '#223e7d' }} className='text-g fw-bold'>معیار های ارزیابی بدو ورود به وندور لیست خراسان</h5>
                        <div className='mt-3 text-g'>
                            <ul>
                                <li>ارائه مدارک ثبتی شرکت اعم از( اساسنامه ، آگهی تاسیس ، گواهی کد شناسه اقتصادی ، گواهی کد شناسه ملی ، آگهی تغییرات ،گواهی ارزش افزوده)</li>
                                <li>تولید کننده بودن / سازنده بودن و یا صرفا تامین کننده</li>
                                <li>دارای نمایندگی انحصاری</li>
                                <li>دارای نمایندگی تجاری</li>
                                <li>موقعیت جغرافیایی</li>
                                <li>ثبت در وندور نفت</li>
                                <li>داشتن ایران کد</li>
                                <li>داشتن گواهینامه های نظام مدیریت</li>
                                <li>داشتن رزومه موفق</li>
                                <li>سابقه فعالیت شرکت</li>
                            </ul>
                        </div>
                    </Col>
                    <Col md={6} className='mt-4'>
                        <h5 style={{ color: '#223e7d' }} className='text-g fw-bold'>معیارهای پایش و ارزیابی پس از خرید</h5>
                        <div className='mt-3 text-g'>
                            <ul>
                                <li>سابقه همکاری با شرکت پتروشیمی خراسان</li>
                                <li>داشتن قیمت رقابتی</li>
                                <li>حسن شهرت</li>
                                <li>تحویل به موقع اقلام خریداری شده</li>
                                <li>پاسخ به موقع به مکاتبات فی مابین</li>
                                <li>ارائه خدمات(خدمات ضمن فروش و پس از فروش)</li>
                                <li>بسته بندی مناسب کالای ارسالی</li>
                                <li>ارائه مشخصات و اطلاعات کافی در پیشنهاد فنی</li>
                                <li>گواهی نامه/ نقشه/کتابچه فنی همراه کالا</li>
                                <li>ارسال به موقع پیشنهادفنی ومالی</li>
                            </ul>
                        </div>
                    </Col>
                    <Col xs={12} md={{ span: 4, offset: 4 }} className='mt-4'>
                        <div className='mb-3'>
                            <Form.Label htmlFor="username">نام کاربری</Form.Label>
                            <Form.Control
                                type="text"
                                id="username"
                                value={username}
                                isInvalid={usernameValid}
                                onChange={(e) => setUsername(e.target.value)}
                            />
                        </div>
                        <div className='mb-4'>
                            <Form.Label htmlFor="inputPassword5">رمزعبور</Form.Label>
                            <Form.Control
                                type="password"
                                id="inputPassword5"
                                value={password}
                                isInvalid={passwordValid}
                                onChange={(e) => serPassword(e.target.value)}
                            />
                        </div>
                        <div className="d-grid gap-2">

                            <Button disabled={submit} onClick={login} variant="success">
                                {
                                    submit ? 'در حال ورود' : 'ورود'
                                }
                            </Button>
                        </div>
                    </Col>
                </Row>
            </Container>

        </>
    )
}